// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"112":"97a34a10","145":"ba330bdb","472":"351ebd07"}[chunkId] + ".js";
};